import { Inject, Injectable } from '@angular/core';
import { ApiRequestService } from '@prekog/common-ui';
import { GetInvoiceRequest } from './getorders/getinvoicerequest';

@Injectable({
    providedIn: 'root'
})
export class OrderService {
    getInvoiceURI = '/admin/getInvoice';
    orderBackendUrl = '';

    constructor(
        private _apiRequestService: ApiRequestService,
        @Inject('ORDER_BACKEND_URL') private _orderBackendUrl: string
    ) {
        this.orderBackendUrl = _orderBackendUrl;
    }

    openInvoice(orderReference: string): void {
        const dowloadBillRequest: GetInvoiceRequest = {
            orderReference: orderReference
        };

        this._apiRequestService
            .sendRequestBlob<GetInvoiceRequest, ArrayBuffer>(this.orderBackendUrl, dowloadBillRequest, true, this.getInvoiceURI)
            .subscribe({
                next: (invoice) => {
                    const mimeType = 'application/pdf';
                    const pdfBlob = new Blob([invoice], { type: mimeType });

                    const fileURL = URL.createObjectURL(pdfBlob);

                    const a = document.createElement('a');
                    document.body.appendChild(a);

                    a.style.display = 'none';
                    a.href = fileURL;
                    a.download = orderReference + '_invoice.pdf';

                    a.click();

                    window.URL.revokeObjectURL(fileURL);
                    document.body.removeChild(a);

                    setTimeout(() => URL.revokeObjectURL(fileURL), 10000);
                }
            });
    }
}
